import type { BulkActionSpinnerProps } from './components/BulkActionSpinner';
import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, createLazyComponent, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "BulkActionsStore" */ './lazyIndex'),
    { name: 'BulkActionsStore' }
);

export const BulkActionSpinner: LazyComponent<BulkActionSpinnerProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.BulkActionSpinner);

export const lazySubscribeToBulkActionNotification: LazyAction<
    typeof lazyIndex.subscribeToBulkActionNotification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.subscribeToBulkActionNotification);
export const lazyOnBulkActionSubmitted: LazyAction<
    typeof lazyIndex.onBulkActionSubmitted,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onBulkActionSubmitted);
export const lazyfindBulkActionItemAction: LazyAction<
    typeof lazyIndex.findBulkActionItemAction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.findBulkActionItemAction);
export const lazyOnBulkActionCancel: LazyAction<
    typeof lazyIndex.onBulkActionCancel,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onBulkActionCancel);
export const lazyOnBulkActionHierarchyNotification: LazyAction<
    typeof lazyIndex.onBulkActionHierarchyNotification,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onBulkActionHierarchyNotification);
export const lazyOnBulkActionDismiss: LazyAction<
    typeof lazyIndex.onBulkActionDismiss,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.onBulkActionDismiss);
